import { render, staticRenderFns } from "./AppScale.vue?vue&type=template&id=11a2a25b&scoped=true&"
import script from "./AppScale.vue?vue&type=script&lang=js&"
export * from "./AppScale.vue?vue&type=script&lang=js&"
import style0 from "./AppScale.vue?vue&type=style&index=0&id=11a2a25b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a2a25b",
  null
  
)

export default component.exports